export { default as StepCard } from "./StepCard.component";
export type { StepCardProps } from "./StepCard.component";
